import { NavigationLink } from 'components/NavigationLink';
import { styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const NavigationLinkStyled = styled(NavigationLink)(({ theme }) => ({
  textDecoration: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  height: 52,
  padding: '3px 12px',
  border: `1px solid ${Colors.gray300}`,
  borderRadius: 8,
  backgroundColor: Colors.blue50,
  color: 'currentColor',
  transition: theme.transitions.create(['background-color']),

  '& .client-name': {
    flexGrow: 1,
  },

  '&:hover': {
    backgroundColor: Colors.blue100,
  },
}));
